export class UploadFileShpINModel {

    codice: string
    area: string
    file: Blob
    idCentrale: number
    storage: string
}
